import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ChatNavBarService {
  public ChatNumber:number;
  public Recipients: Set<string> = new Set<string>();
}